import { ReactElement } from "react";
import type { DevShellDeviceType } from "../../shared/deviceType";
import { EXPRESS_DEVICE_TYPE_OPTIONS } from "../../shared/deviceType";

interface DeviceTypeToggleProps {
  deviceType: DevShellDeviceType;
  onDeviceTypeChange: (deviceType: DevShellDeviceType) => void;
}

export const DeviceTypeToggle = ({
  deviceType,
  onDeviceTypeChange,
}: DeviceTypeToggleProps): ReactElement => {
  return (
    <div className="device-type-toggle" role="group" aria-label="Device type simulation">
      {EXPRESS_DEVICE_TYPE_OPTIONS.map(({ value, label, iconClass }) => (
        <button
          key={value}
          type="button"
          className={`menu-item ${iconClass}${deviceType === value ? " is-active" : ""}`}
          aria-label={label}
          aria-pressed={deviceType === value}
          title={label}
          onClick={(): void => {
            if (deviceType !== value) {
              onDeviceTypeChange(value);
            }
          }}
        />
      ))}
    </div>
  );
};
